var $ = require('jquery');
import Splide from '@splidejs/splide';
import 'magnific-popup';


$(document).ready(function () {
    //  initSlider();
    initPopup();
    listingPopup();
    showPublicationPopUp();
});

function initSlider() {
    if ($('.publications').length) {
        new Splide('.publications', {
            type: 'fade',
            perPage: 1,
            pagination: false,
            autoplay: false
        }).mount();
    }
}

function initPopup() {
    $('.publication__read-more').off('click').on('click', function (e) {
        e.preventDefault();

        const popup = $(this).next('.publication-popup');
        $.magnificPopup.open({
            items: {
                src: popup
            },
            type: 'inline',
            removalDelay: 300,
            mainClass: 'mfp-fade',
            showCloseBtn: false
        });
    });
    $('.site-popup__close').off('click').on('click', function (e) {
        e.preventDefault();

        $.magnificPopup.close();
    });
}

function listingPopup() {
    $('.publications-listing-popup-trigger').magnificPopup({
        type: 'inline',
        closeOnBgClick: true,
        fixedContentPos: false,
        autoFocusLast: false,
        closeBtnInside: true,
        mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
        fixedContentPos: true,
    });
}

function showPublicationPopUp() {
    $('.publication-popup-trigger').magnificPopup({
        type: 'inline',
        closeOnBgClick: true,
        fixedContentPos: false,
        autoFocusLast: false,
        closeBtnInside: true,
        mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
        fixedContentPos: true,
    });
    $('.site-popup__close--publication').on('click', function () {
        $('.publication-popup-close').magnificPopup('close');
        $('.publications-listing-popup-trigger').trigger("click");
    });

}